/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
import { __extends } from "tslib";
import { alCallProperty } from '../runtime';
import { wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1Object } from '../runtime/AVM1Object';
import { AVM1Globals } from './AVM1Globals';
import { MouseEvent as AwayMouseEvent } from '@awayjs/scene';
var AVM1Mouse = /** @class */ (function (_super) {
    __extends(AVM1Mouse, _super);
    function AVM1Mouse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Mouse.createAVM1Class = function (context) {
        var wrapped = wrapAVM1NativeClass(context, false, AVM1Mouse, ['show', 'hide'], []);
        return wrapped;
    };
    AVM1Mouse.bindStage = function (_context, cls, avmStage, _htmlElement) {
        AVM1Mouse.mouseButtonsState[1 /* ASNativeMouseCodes.LEFT */] = 0;
        AVM1Mouse.mouseButtonsState[4 /* ASNativeMouseCodes.MIDDLE */] = 0;
        AVM1Mouse.mouseButtonsState[2 /* ASNativeMouseCodes.RIGHT */] = 0;
        var stage = avmStage.view.stage;
        if (AVM1Mouse.mouseDownDelegate)
            stage.removeEventListener(AwayMouseEvent.MOUSE_DOWN, AVM1Mouse.mouseDownDelegate);
        if (AVM1Mouse.mouseMoveDelegate)
            stage.removeEventListener(AwayMouseEvent.MOUSE_MOVE, AVM1Mouse.mouseMoveDelegate);
        if (AVM1Mouse.mouseOutDelegate)
            stage.removeEventListener(AwayMouseEvent.MOUSE_OUT, AVM1Mouse.mouseOutDelegate);
        if (AVM1Mouse.mouseUpDelegate)
            stage.removeEventListener(AwayMouseEvent.MOUSE_UP, AVM1Mouse.mouseUpDelegate);
        AVM1Mouse.mouseDownDelegate = function (e) {
            var _a;
            // ?? = (a === undef || null) ? b : a;
            var buttons = (_a = e.buttons) !== null && _a !== void 0 ? _a : 0;
            AVM1Mouse.mouseButtonsState[buttons & 1 /* MouseButtons.PRIMARY_BUTTON */] = 1;
            AVM1Mouse.mouseButtonsState[buttons & 2 /* MouseButtons.SECONDARY_BUTTON */] = 1;
            AVM1Mouse.mouseButtonsState[buttons & 4 /* MouseButtons.AUXILLARY_BUTTON */] = 1;
            // we should not handle middle mouse, because FLASH can use it
            if (buttons === 4) {
                return;
            }
            alCallProperty(cls, 'broadcastMessage', ['onMouseDown']);
        };
        AVM1Mouse.mouseMoveDelegate = function (_e) {
            alCallProperty(cls, 'broadcastMessage', ['onMouseMove']);
        };
        AVM1Mouse.mouseOutDelegate = function (_e) {
            alCallProperty(cls, 'broadcastMessage', ['onMouseOut']);
        };
        AVM1Mouse.mouseUpDelegate = function (e) {
            var _a;
            // ?? = (a === undef || null) ? b : a;
            var buttons = (_a = e.buttons) !== null && _a !== void 0 ? _a : 0;
            // reset latest mouse,  but this is not fully valid implementation
            AVM1Mouse.mouseButtonsState[buttons & 1 /* MouseButtons.PRIMARY_BUTTON */] = 1;
            AVM1Mouse.mouseButtonsState[buttons & 2 /* MouseButtons.SECONDARY_BUTTON */] = 1;
            AVM1Mouse.mouseButtonsState[buttons & 4 /* MouseButtons.AUXILLARY_BUTTON */] = 1;
            // we should not handle middle mouse, because FLASH can't use it
            if (buttons === 4) {
                return;
            }
            alCallProperty(cls, 'broadcastMessage', ['onMouseUp']);
        };
        stage.addEventListener(AwayMouseEvent.MOUSE_DOWN, AVM1Mouse.mouseDownDelegate);
        stage.addEventListener(AwayMouseEvent.MOUSE_MOVE, AVM1Mouse.mouseMoveDelegate);
        stage.addEventListener(AwayMouseEvent.MOUSE_OUT, AVM1Mouse.mouseOutDelegate);
        stage.addEventListener(AwayMouseEvent.MOUSE_UP, AVM1Mouse.mouseUpDelegate);
    };
    AVM1Mouse.hide = function () {
        AVM1Globals.instance.Stage.avmStage.mouseManager.showCursor = false;
    };
    AVM1Mouse.show = function () {
        AVM1Globals.instance.Stage.avmStage.mouseManager.showCursor = true;
    };
    AVM1Mouse.mouseButtonsState = (_a = {},
        _a[1 /* ASNativeMouseCodes.LEFT */] = 0,
        _a[4 /* ASNativeMouseCodes.MIDDLE */] = 0,
        _a[2 /* ASNativeMouseCodes.RIGHT */] = 0,
        _a);
    AVM1Mouse.mouseDownDelegate = null;
    AVM1Mouse.mouseMoveDelegate = null;
    AVM1Mouse.mouseOutDelegate = null;
    AVM1Mouse.mouseUpDelegate = null;
    return AVM1Mouse;
}(AVM1Object));
export { AVM1Mouse };
